import { useState, useEffect } from "react";
import { Guidebook } from "../types/guidebook";
import { paths, API_URL } from "../config/endpoints";

export const useGuidebookShare = (shortCode: string) => {
  const [guidebook, setGuidebook] = useState<Guidebook | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchGuidebookByShare = async () => {
      setLoading(true);
      setError(null);

      try {
        const headers: HeadersInit = {
          "Content-Type": "application/json",
        };

        const apiUrl = `${API_URL}/${paths.guest}/${paths.guidebooks}/${paths.share}/${shortCode}`;
        const response = await fetch(apiUrl, {
          method: "GET",
          headers,
        });

        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("Guidebook not found");
          } else if (response.status === 401) {
            throw new Error("Unauthorized: Invalid authentication credentials");
          } else if (response.status === 403) {
            throw new Error("Forbidden: You don't have access to this guidebook");
          } else {
            throw new Error("Failed to fetch guidebook");
          }
        }

        const data = await response.json();
        setGuidebook(data);
      } catch (error: any) {
        setError(error.message || "An error occurred while fetching guidebook");
      } finally {
        setLoading(false);
      }
    };

    if (shortCode) {
      fetchGuidebookByShare();
    } else {
      setGuidebook(null);
      setLoading(false);
    }
  }, [shortCode]);

  return { guidebook, loading, error };
};
